import type { FeatureGroup } from '@aibees/shared/definition';

export enum CurrentPlanVariant {
  CUSTOM = 'custom',
  LEGACY = 'legacy',
}

export interface CurrentPlanData {
  variant: CurrentPlanVariant;
  name: string;
  price: number;
  monthLabel: string;
  rate: string;
  credits: string;
  requestCount: number;
  seats: string;
  rollover: string;
  support: string;
  renewal: string;
  featureGroups: FeatureGroup[];
}

export interface CurrentPlanBannerProps {
  className?: string;
}

export interface VariantCopy {
  title: string;
  summaryTitle: string;
  inclusionTitle: string;
  inclusionKicker: string;
}
